<template lang="html">
  <section id="recover">
    <!-- User triggers a recovery -->
    <section v-if="!recovering" class="section">
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <div class="container">
          <div class="columns is-centered">
            <div class="column is-6">
              <h1 class="title is-size-5 has-text-weight-medium has-text-dark-orange">
                <b-icon type="is-primary" icon="refresh-circle"></b-icon>
                Reset your password
              </h1>

              <small>
                Enter your username or email address and we’ll send a link to reset your
                password.
              </small>

              <ValidationProvider slim rules="required|email" name="Email" v-slot="{ errors, valid }">
                <b-field label="Email" :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="[errors[0]]">
                  <b-input type="text" v-model="login" placeholder="Your email or username"></b-input>
                </b-field>
              </ValidationProvider>
              <div class="py-3">
                <vue-recaptcha ref="recaptcha" sitekey="6LeeROAZAAAAAAslfpwt5vHim5E-sQA83zGOHMRP" @verify="captcha = true" :loadRecaptchaScript="true"></vue-recaptcha>
              </div>
              <b-button tag="input" native-type="submit" :disabled="!captcha" type="is-primary" @click.prevent="handleSubmit(recover)" @keyup.enter="handleSubmit(recover)">
                Send email
              </b-button>
            </div>
          </div>
        </div>
      </ValidationObserver>
    </section>

    <!-- User resetting his password -->
    <section v-if="recovering" class="section">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-6">
            <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
              <h1 class="title is-size-5 has-text-weight-medium has-text-dark-orange">
                <b-icon type="is-primary" icon="refresh-circle"></b-icon>
                Choose a new password
              </h1>
              <div class="content">
                <ValidationProvider
                  slim
                  rules="required|between:6,30"
                  name="Password"
                  v-slot="{ errors, valid }"
                >
                  <b-field
                    label="Password"
                    :type="{ 'is-danger': errors[0], 'is-success': valid }"
                    :message="[
                      errors[0],
                      'The password should be minimum six characters length, contain one capital letter and one number (+ an elfic character from an old spell book)',
                    ]"
                  >
                    <b-input
                      v-model="resetParams.password"
                      type="password"
                      autocomplete="new-password"
                      name="password"
                      spellcheck="false"
                      password-reveal
                      required
                    >
                    </b-input>
                  </b-field>
                </ValidationProvider>

                <ValidationProvider
                  slim
                  rules="required|confirmed:Password"
                  name="Password confirmation"
                  v-slot="{ errors, valid }"
                >
                  <b-field
                    label="Password confirmation"
                    :type="{ 'is-danger': errors[0], 'is-success': valid }"
                    :message="[errors[0], 'Enter the same password a second time']"
                  >
                    <b-input
                      v-model="resetParams.password_confirmation"
                      type="password"
                      autocomplete="new-password"
                      name="password-confirmation"
                      spellcheck="false"
                      password-reveal
                      required
                    >
                    </b-input>
                  </b-field>
                </ValidationProvider>
              </div>

              <b-button type="is-primary" @click.prevent="handleSubmit(resetPassword)">
                Confirm
              </b-button>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import VueRecaptcha from 'vue-recaptcha'
import RecoverySentModal from '@/views/Recover/RecoverySentModal'

export default {
  data () {
    return {
      login: null,
      recovering: false,
      captcha: false,
      resetParams: {
        reset_password_token: null,
        password: null,
        password_confirmation: null
      }
    }
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    VueRecaptcha
  },
  methods: {
    recover () {
      this.$store
        .dispatch('recoveries/create', this.login)
        .then(() => {
          this.$buefy.modal.open({
            parent: this,
            component: RecoverySentModal,
            hasModalCard: true,
            customClass: 'custom-class custom-class-2',
            trapFocus: true
          })
          this.login = null
          this.captcha = false
          this.$refs.recaptcha.reset()
        })
        // TODO: Handle error
        .catch(() => {})
    },
    resetPassword () {
      this.$store
        .dispatch('recoveries/update', this.resetParams)
        .then(() => {
          this.$buefy.notification.open({
            message: 'Your password has been reset, you can now login!',
            position: 'is-top',
            type: 'is-success'
          })
          this.$router.push('/')
        })
        // TODO: Handle error
        .catch(() => {})
    }
  },
  mounted () {
    if (this.$route.query.token) {
      this.resetParams.reset_password_token = this.$route.query.token
      this.recovering = true
    } else {
      this.recovering = false
    }
  }
}
</script>

<style lang="css" scoped></style>
